import { useQuery } from '@apollo/client';
import { graphql } from '@packages/network-graphql/graphql/types';
import { useFocusedCompanyContext } from '@packages/core/company/focused-company-context.ts';

const GET_BRANCH = graphql(`
  query CompanyBranches($companyId: ID!) {
    branches(companyId: $companyId) {
      ...BranchItem
    }
  }
`);

export function useBranchList() {
  const companyContext = useFocusedCompanyContext();
  return useQuery(GET_BRANCH, {
    variables: {
      companyId: companyContext.id,
    },
  });
}
